import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";


import {
    FvmsCommonService
    ,FvmsExcelService
    ,FvmsApiDtgDriverService
    ,FvmsApiDtgUserService
    ,FvmsApiAuthService
    ,FvmsApiDtgTeamService
} from "src/app/shared/service";
import {
    FilterDateDiff
    ,FilterDist
    ,FilterSecToTime
} from "src/app/shared/filter";
import {
    PagingInfo
    ,DtgDriverInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import { DtgManageDriverFormComponent } from "src/app/dtg/manage/driver/form/dtg.manage.driver.form.component";
import { Workbook } from 'exceljs';
import { Validators } from '@angular/forms';

@Component({
    selector: "dtg-manage-driver-list"
    ,templateUrl: './dtg.manage.driver.list.component.html'
    ,providers: [FilterDateDiff]
})
export class DtgManageDriverListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    listDriver:any[] = [];
    searchValue:string="";
    pagingInfo:PagingInfo = new PagingInfo();
    dtgDriverInfo:DtgDriverInfo = new DtgDriverInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    companyInfo:any;
    dateInfo:any;
    dayDiff:number=0;
    @Input() listType:DtgListType = DtgListType.list;
    @Output() driverInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number = 1000;
    limitUserGroupId:number;
    dtgTeamId:string = "";
    listTeam:any[];

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsExcelService:FvmsExcelService
        ,private filterDateDiff:FilterDateDiff
        ,private fvmsApiDtgDriverService:FvmsApiDtgDriverService
        ,private fvmsApiDtgUserService:FvmsApiDtgUserService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.limitUserGroupId = this.currentUserInfo.userGroupId;
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 10;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadDriverList();
            });
    }

    ngOnInit() {
        this.excelPagingInfo.pageSize=999999;
        this.reloadListItemTeam();
        this.reloadDriverList();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {

    }


    reloadDriverList(){
        this.pagingInfo.curPage=1;
        this.selectDriverList();
    };

    selectDriverList(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.dtgTeamId
            ,userId : null
            ,searchValue : this.searchValue
            ,userGroupId : this.userGroupId
            ,limitUserGroupId : this.limitUserGroupId
        };
        this.fvmsApiDtgUserService.getListUser(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listDriver = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.companyInfo.companyId || 0
            ,dtgTeamId : this.currentUserInfo.teamId
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    clickOpenModalFormDriverInfo(dtgActionType:DtgActionType,dtgDriverInfo:DtgDriverInfo){
        let modalRef = this.modalService.open(
            DtgManageDriverFormComponent
            ,{
                centered:true
                // ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = dtgDriverInfo?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.userId = dtgDriverInfo?.userId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.selectDriverList();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.selectDriverList();
    }


    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    changeTeamInfo(event){
        this.reloadDriverList();
    }

    // check userId (string array)
    async checkSameIds(userIds: any){
        let searchInfo = userIds;
        let result = await this.fvmsApiAuthService.checkSameIds(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    return (apiResponse.resultValue === 0);
                }
            });
        return result;
    }

    validateUserInfo(userInfo): boolean {
        // 1. 필수 항목 확인 (userId, userPw, companyId, userGroupId(사용자 권한))
        if (!userInfo ||
            !userInfo.userId ||
            !userInfo.userPw ||
            !userInfo.companyId ||
            !userInfo.userGroupId) {

            return false;
        }

        // 3. dtgDriverLcsNo이 있을경우 Data 형식 확인
        if (userInfo.dtgDriverLcsNo &&
            !Validators.maxLength(18) &&
            !Validators.pattern("[0-9]{0,18}")) {

            return false;
        }

        return true;
    }

    async regUserInfos( userInfos: Array<any>) {
        // upsert userInfo
        let resultState = true;
        await userInfos.forEach(userInfo => {
            this.fvmsApiDtgUserService.upsertUser(userInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    if(apiResponse.resultStatus === "ok"){
                        // console.log("new user id",apiResponse.resultValue.userId);
                        // 사용자 차량 운행 등록
                        // this.fvmsApiDtgUserService.upsertUserCarRunLast(userInfo)
                        //     .pipe(takeWhile(() => this.isContinue))
                        //     .subscribe(apiResponse2 => {
                        //         console.log("new user id",apiResponse2.resultValue.userId);
                        //     });
                        resultState = resultState && true;
                    } else {
                        resultState = false;
                        let requestFailMessage = apiResponse.resultMessage;
                        alert(requestFailMessage);
                    }
                });
        });
        return resultState;
    }

    makeUserInfo(colInfos: Array<string>, rowData: Array<any>): object {
        /*
        let userInfo = {
            userId:userId.value
            ,userNm:userNm.value
            ,userPw:userPw.value
            ,companyId:companyId.value  ->> 코드에서 추가 (선택된 회사 ID) : testId = 2
            ,userGroupId:userGroupId.value  ->> 권한 그룹 ( 고정 ) 1000
            ,userGroupNm:userGroupNm.value  ->> 권한 그룹 ( 고정 ) 운전자
            ,dtgDriverNm:dtgDriverNm.value  ->> 코드에서 추가 (null)
            ,dtgDriverLcsNo:dtgDriverLcsNo.value
            ,userBirthDt:userBirthDt.value
            ,userHireDt:userHireDt.value
            ,dtgTeamId:dtgTeamId.value
            ,email:email.value
            ,mobile:mobile.value
            ,memo:memo.value
            ,useYn:useYn.value
            ,createUser:this.currentUserInfo.userId  ->> 코드에서 추가 (현제 로그인 사용자)
            ,updateUser:this.currentUserInfo.userId  ->> 코드에서 추가 (현제 로그인 사용자)
            ,dtgUnitId:dtgUnitId.value  ->> 코드에서 추가 (null)
        };
        */

        let userInfo = {};
        colInfos.forEach((col: string, idx: number) => {
            let colValue = rowData[idx];
            if ((col == 'userBirthDt' || col == 'userHireDt') &&
                (colValue && (typeof colValue) !== 'string')) {

                let yyyy = colValue.getFullYear().toString();
                let mm = (colValue.getMonth() + 1).toString();
                mm = mm >= 10 ? mm : '0' + mm;
                let dd = colValue.getDate();
                dd = dd >= 10 ? dd : '0' + dd;

                colValue = yyyy + '-' + mm + '-' + dd;
            }

            userInfo[col] = (colValue) ? colValue.toString() : null;
        });
        userInfo['companyId'] = this.companyInfo.companyId;
        userInfo['userGroupId'] = '1000'; // 운전자 고정.
        userInfo['createUser'] = this.currentUserInfo.userId;
        userInfo['updateUser'] = this.currentUserInfo.userId;
        userInfo['useYn'] = 'Y';

        return userInfo;
    }

    userRegFromExcel(e) {
        if (e.target.files.length == 0) {
          console.log("파일을 선택해 주세요.");
          return;
        }
        let file:File = e.target.files[0];
        let fileReader:FileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onloadend = (ev) => {
            let fileBuff = fileReader.result as ArrayBuffer;
            const wb = new Workbook();
            wb.xlsx.load(fileBuff).then(book => {
                let columnInfos:any = [];
                let targetUserInfoList = [];
                book.eachSheet((sheetItem,sheetIdx) => {
                    sheetItem.eachRow((rowItem,rowIdx) => {
                        // column 정보 없음.
                        if (rowIdx == 1) {
                            console.log('start to register user');
                        } else if (rowIdx == 2 && !rowItem) {
                            throw new Error('not found Resource Infos.')
                        } else if (rowIdx == 2) {
                            columnInfos = rowItem.values;
                            // Excel의 index는 1부터 시작 -> '0' index 제거
                            columnInfos.shift();
                        } else {
                            // create userInfo (사용자 정보 작성)
                            let item:any = rowItem.values;
                            // Excel의 index는 1부터 시작 -> '0' index 제거
                            item.shift();
                            targetUserInfoList.push(this.makeUserInfo(columnInfos, item));
                        }
                    });
                });

                let userIds = [];
                // 읽어온 데이터 검증 및 Message 출력
                let isInvalid = targetUserInfoList.some(userInfo => {
                    let chkUserInfo = this.validateUserInfo(userInfo);
                    if (!chkUserInfo) {
                        alert('excel의 입력 데이터가 잘못되었습니다.\n확인 부탁드립니다.');
                        return true;
                    }
                    // 입력될 사용자의 중복ID 확인
                    if (userIds.includes(userInfo.userId)) {
                        alert('중복 ID가 존재합니다.');
                        return true;
                    }
                    userIds.push(userInfo.userId);
                });
                // Validation 확인
                if (isInvalid) {
                    return;
                }

                // ID 중복 확인
                let chkUserId = this.checkSameIds(userIds);
                if (!chkUserId) {
                  alert('중복 ID가 존재합니다.')
                  return false;
                }

                // 운전자 생성.
                const regState = this.regUserInfos(targetUserInfoList);
                if (regState) {
                    alert("운전자 정보 " + targetUserInfoList.length + "건의 등록이 완료되었습니다.")
                    this.reloadDriverList();
                }
            });
        };
    }

    excelDownload(){
        this.fvmsCommonService.setIsLoading(true);
        this.dtgDriverInfo.dtgEid=this.companyInfo.dtgEid;
        this.dtgDriverInfo.companyId=this.companyInfo.companyId;
        this.dtgDriverInfo.driverGroupIdArrStr=this.fvmsCommonService.getDriverGroupIdArrStr()
        this.fvmsApiDtgDriverService.getDriverList(this.dtgDriverInfo,this.excelPagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.fvmsExcelService.excelDownload(this.convertExcelJson(apiResponse.resultValue),"driverList");
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    convertExcelJson(dataList:any[]){
        let resultList = [];
        let cnt = dataList.length;
        dataList.map((v,i) => {
            resultList.push({
                "No":cnt-i
                ,"ID":v.userId
                ,"운전자이름":v?.userDriverNm||"미지정"
                ,"운수종사자ID":v?.drvKotsaDriverId||"미지정"
                ,"생년월일":v?.userBirthDt||"미지정"
                ,"입사일자":v?.userHireDt||"미지정"
            })
        });
        return resultList;
    }

    clickSelectDriver(driverInfo:any){
        this.driverInfo.emit(driverInfo);
    }
}
